import axios from 'axios';
import { config } from '../config';
import { bots } from '../data/bots';
import type { 
  ApiResponse,
  LoginResponse,
  CouponResponse,
  CouponListResponse,
  PaymentVerificationResponse,
  UsageHistoryResponse,
  NewsResponse,
  AdminUsersResponse,
  AdminAnalyticsResponse,
  SupportTicketResponse
} from '../types/api';
import type { User } from '../types';

// Create API instance with base configuration
const api = axios.create({
  baseURL: config.apiUrl,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor to add auth token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('auth-token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor for better error handling
api.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      console.error('Auth Error:', {
        status: error.response.status,
        message: error.response.data?.message,
        url: error.config?.url
      });
      localStorage.removeItem('auth-token');
    }
    throw new Error(error.response?.data?.message || error.message);
  }
);

export default api;